import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Header, Segment, Form, Input, Button, Modal, Table, Icon } from 'semantic-ui-react';
import { hideLoading, getBookletPricing, getProductOptions, updateBookletPricingTable } from '../actions';
import _ from 'lodash';

class DigitalBooklet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product_name: 'Digital Booklet',
            pricing: []
        }

        document.title = `U-Tech Admin - ${this.state.product_name} ${props.offline ? '(Offline)' : ''}`
        // this.props.getProductOptions(this.state.product_name);
        this.props.getBookletPricing(this.state.product_name, this.props.offline);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.product.pricing !== nextProps.product.pricing) {
            console.log('Pricing changed!');
            console.log(nextProps.product);
            if (nextProps.product.pricing) {
                let pricing = JSON.parse(JSON.stringify(nextProps.product.pricing));
                pricing.material.new = { weight: 0, paper_type: '', unit_price: 0.0 };
                pricing.printing.forEach((printing, index) => {
                    pricing.printing[index].new = { from: 0, unit_price: 0.0 };
                });
                pricing.wire_o.new = { paper_size: '', cutoff_quantity: 0, low_qty_unit_price: 0.0, high_qty_unit_price: 0.0, min_price: 0.0 };
                this.setState({ pricing: pricing });
                this.props.hideLoading();
            }
        }
    }

    handleEditClicked(id, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                console.log(newArr[id].edit);
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = JSON.parse(JSON.stringify(this.props.product.pricing.material));
                    newArr[id].new = { weight: 0, paper_type: '', unit_price: 0.0 };
                }
                this.setState({ pricing: newArr });
                break;

            case 'printing':
                newArr[id][idx].edit = !newArr[id][idx].edit;
                if (!newArr[id][idx].edit) {
                    newArr[id][idx] = JSON.parse(JSON.stringify(this.props.product.pricing.printing[idx]));
                    newArr[id][idx].new = { from: 0, unit_price: 0.0 };
                }
                this.setState({ pricing: newArr });
                break;

            case 'lamination':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = JSON.parse(JSON.stringify(this.props.product.pricing.lamination));
                }
                this.setState({ pricing: newArr });
                break;

            case 'wire_o':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = JSON.parse(JSON.stringify(this.props.product.pricing.wire_o));
                    newArr[id].new = { paper_size: '', cutoff_quantity: 0, low_qty_unit_price: 0, high_qty_unit_price: 0, min_price: 0 };
                }
                this.setState({ pricing: newArr });
                break;

            case 'misc':
                newArr[id].edit = !newArr[id].edit;
                if (!newArr[id].edit) {
                    newArr[id] = JSON.parse(JSON.stringify(this.props.product.pricing.misc));
                }
                this.setState({ pricing: newArr });
                break;

            default:
                break;
        }
    }

    handleRowDelete(id, row, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
            case 'wire_o':
                if (newArr[id].edit) {
                    newArr[id].prices.splice(row, 1);
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].edit) {
                    newArr[id][idx].prices.splice(row, 1);
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleTableInputChange(id, row, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
            case 'wire_o':
                if (newArr[id].edit) {
                    if (row === -1) {
                        newArr[id].new[e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    } else {
                        newArr[id].prices[row][e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].edit) {
                    if (row === -1) {
                        newArr[id][idx].new[e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    } else {
                        newArr[id][idx].prices[row][e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleGroupInputChange(id, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
            case 'lamination':
            case 'misc':
                if (newArr[id].edit) {
                    newArr[id][e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].edit) {
                    newArr[id][idx][e.target.name] = e.target.value.match(/^(\d*\.)?\d+$/) ? parseFloat(e.target.value) : e.target.value;
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }

    }

    handleResetRow(id, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].edit) {
                    newArr[id].new['weight'] = '';
                    newArr[id].new['paper_type'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].error = false;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].edit) {
                    newArr[id][idx].new['from'] = '';
                    newArr[id][idx].new['unit_price'] = '';
                    newArr[id][idx].error = false;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'wire_o':
                if (newArr[id][idx].edit) {
                    newArr[id][idx].new['paper_size'] = '';
                    newArr[id][idx].new['cutoff_quantity'] = '';
                    newArr[id][idx].new['low_qty_unit_price'] = '';
                    newArr[id][idx].new['high_qty_unit_price'] = '';
                    newArr[id][idx].new['min_price'] = '';
                    newArr[id][idx].error = false;
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleAddRow(id, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].add) {
                    if (newArr[id].new['weight'] &&
                        (newArr[id].new['paper_type'].length > 0) &&
                        newArr[id].new['unit_price']) {

                        let newObj = {
                            weight: parseInt(newArr[id].new['weight']),
                            paper_type: newArr[id].new['paper_type'].trim(),
                            unit_price: parseFloat(newArr[id].new['unit_price'])
                        };

                        if (newArr[id].prices.findIndex(el => ((el.weight === newObj.weight) && (el.paper_type === newObj.paper_type))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['weight'] = '';
                            newArr[id].new['paper_type'] = '';
                            newArr[id].new['unit_price'] = '';
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['weight', 'paper_type'], ['asc', 'asc']);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].error = true;
                    }
                    this.setState({ pricing: newArr });
                } else {
                    newArr[id].new['weight'] = '';
                    newArr[id].new['paper_type'] = '';
                    newArr[id].new['unit_price'] = '';
                    newArr[id].add = true;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].add) {
                    if (newArr[id][idx].new['from'] &&
                        newArr[id][idx].new['unit_price']) {

                        let newObj = {
                            from: parseInt(newArr[id][idx].new['from']),
                            unit_price: parseFloat(newArr[id][idx].new['unit_price'])
                        };

                        if (newArr[id][idx].prices.findIndex((el) => el.from === newObj.from) === -1) {
                            newArr[id][idx].prices.push(newObj);
                            newArr[id][idx].new['from'] = '';
                            newArr[id][idx].new['unit_price'] = '';
                            newArr[id][idx].prices.sort((a, b) => a.from - b.from);
                        } else {
                            newArr[id][idx].error = true;
                        }
                    } else {
                        newArr[id][idx].error = true;
                    }
                    this.setState({ pricing: newArr });
                } else {
                    newArr[id][idx].new['from'] = '';
                    newArr[id][idx].new['unit_price'] = '';
                    newArr[id][idx].add = true;
                    this.setState({ pricing: newArr });
                }
                break;

            case 'wire_o':
                if (newArr[id].add) {
                    if ((newArr[id].new['paper_size'].length > 0) &&
                        (newArr[id].new['cutoff_quantity']) &&
                        (newArr[id].new['low_qty_unit_price']) &&
                        (newArr[id].new['high_qty_unit_price']) &&
                        (newArr[id].new['min_price'])) {

                        let newObj = {
                            paper_size: newArr[id].new['paper_size'].trim(),
                            cutoff_quantity: parseInt(newArr[id].new['cutoff_quantity']),
                            low_qty_unit_price: parseFloat(newArr[id].new['low_qty_unit_price']),
                            high_qty_unit_price: parseFloat(newArr[id].new['high_qty_unit_price']),
                            min_price: parseFloat(newArr[id].new['min_price'])
                        };

                        if (newArr[id].prices.findIndex(el => (el.paper_size === newObj.paper_size)) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['paper_size'] = '';
                            newArr[id].new['cutoff_quantity'] = '';
                            newArr[id].new['low_qty_unit_price'] = '';
                            newArr[id].new['high_qty_unit_price'] = '';
                            newArr[id].new['min_price'] = '';
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_size'], ['asc']);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].error = true;
                    }
                    this.setState({ pricing: newArr });
                } else {
                    newArr[id].new['paper_size'] = '';
                    newArr[id].new['cutoff_quantity'] = '';
                    newArr[id].new['low_qty_unit_price'] = '';
                    newArr[id].new['high_qty_unit_price'] = '';
                    newArr[id].new['min_price'] = '';
                    newArr[id].add = true;
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    handleSaveClicked(id, idx, e) {
        let newArr = this.state.pricing;

        switch (id) {
            case 'material':
                if (newArr[id].edit) {
                    if ((newArr[id].new['weight']) && (newArr[id].new['paper_type'].length > 0) && (newArr[id].new['unit_price'])) {
                        let newObj = {
                            weight: parseInt(newArr[id].new['weight']),
                            paper_type: newArr[id].new['paper_type'].trim(),
                            unit_price: parseFloat(newArr[id].new['unit_price'])
                        };
                        if (newArr[id].prices.findIndex(el => ((el.weight === newObj.weight) && (el.paper_type === newObj.paper_type))) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['weight'] = '';
                            newArr[id].new['paper_type'] = '';
                            newArr[id].new['unit_price'] = '';
                            newArr[id].error = false;
                            newArr[id].edit = false;
                            newArr[id].add = false;
                            newArr[id].min_paper_price = (newArr[id].min_paper_price) ? newArr[id].min_paper_price : 0.0;
                            newArr[id].min_card_price = (newArr[id].min_card_price) ? newArr[id].min_card_price : 0.0;
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['weight', 'paper_type'], ['asc', 'asc']);
                            this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { prices: newArr[id].prices, min_paper_price: newArr[id].min_paper_price, min_card_price: newArr[id].min_card_price } }, this.props.offline);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].edit = false;
                        newArr[id].add = false;
                        newArr[id].error = false;
                        newArr[id].min_paper_price = (newArr[id].min_paper_price) ? newArr[id].min_paper_price : 0.0;
                        newArr[id].min_card_price = (newArr[id].min_card_price) ? newArr[id].min_card_price : 0.0;
                        newArr[id].prices = _.orderBy(newArr[id].prices, ['weight', 'paper_type'], ['asc', 'asc']);
                        this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { prices: newArr[id].prices, min_paper_price: newArr[id].min_paper_price, min_card_price: newArr[id].min_card_price } }, this.props.offline);
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            case 'printing':
                if (newArr[id][idx].edit) {
                    if ((newArr[id][idx].new['from']) && (newArr[id][idx].new['unit_price'])) {
                        let newObj = {
                            from: parseInt(newArr[id][idx].new['from']),
                            unit_price: parseFloat(newArr[id][idx].new['unit_price'])
                        };
                        if (newArr[id][idx].prices.findIndex((el) => el.from === newObj.from) === -1) {
                            newArr[id][idx].prices.push(newObj);
                            newArr[id][idx].new['from'] = '';
                            newArr[id][idx].new['unit_price'] = '';
                            newArr[id][idx].error = false;
                            newArr[id][idx].edit = false;
                            newArr[id][idx].add = false;
                            newArr[id][idx].min_printing_price = (newArr[id][idx].min_printing_price) ? newArr[id][idx].min_printing_price : 0.0;
                            newArr[id][idx].prices.sort((a, b) => a.from - b.from);
                            this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: newArr[id].map((item) => { return { type: item.type, material: item.material, prices: item.prices, min_printing_price: item.min_printing_price } }) }, this.props.offline);
                        } else {
                            newArr[id][idx].error = true;
                        }
                    } else {
                        newArr[id][idx].edit = false;
                        newArr[id][idx].add = false;
                        newArr[id][idx].error = false;
                        newArr[id][idx].min_printing_price = (newArr[id][idx].min_printing_price) ? newArr[id][idx].min_printing_price : 0.0;
                        this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: newArr[id].map((item) => { return { type: item.type, material: item.material, prices: item.prices, min_printing_price: item.min_printing_price } }) }, this.props.offline);
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            case 'lamination':
                if (newArr[id].edit) {
                    newArr[id].one_sided_min_price = (newArr[id].one_sided_min_price) ? newArr[id].one_sided_min_price : 0.0;
                    newArr[id].two_sided_min_price = (newArr[id].two_sided_min_price) ? newArr[id].two_sided_min_price : 0.0;
                    newArr[id].price_per_sq_inch = (newArr[id].price_per_sq_inch) ? newArr[id].price_per_sq_inch : 0.0;
                    newArr[id].edit = false;
                    this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { one_sided_min_price: newArr[id].one_sided_min_price, two_sided_min_price: newArr[id].two_sided_min_price, price_per_sq_inch: newArr[id].price_per_sq_inch } }, this.props.offline);
                    this.setState({ pricing: newArr });
                }
                break;

            case 'wire_o':
                if (newArr[id].edit) {
                    if ((newArr[id].new['paper_size'].length > 0) && (newArr[id].new['cutoff_quantity']) && (newArr[id].new['low_qty_unit_price']) && (newArr[id].new['high_qty_unit_price']) && (newArr[id].new['min_price'])) {
                        let newObj = {
                            paper_size: newArr[id].new['paper_size'].trim(),
                            cutoff_quantity: parseInt(newArr[id].new['cutoff_quantity']),
                            low_qty_unit_price: parseFloat(newArr[id].new['low_qty_unit_price']),
                            high_qty_unit_price: parseFloat(newArr[id].new['high_qty_unit_price']),
                            min_price: parseFloat(newArr[id].new['min_price'])
                        };
                        if (newArr[id].prices.findIndex(el => (el.paper_size === newObj.paper_size)) === -1) {
                            newArr[id].prices.push(newObj);
                            newArr[id].new['paper_size'] = '';
                            newArr[id].new['cutoff_quantity'] = '';
                            newArr[id].new['low_qty_unit_price'] = '';
                            newArr[id].new['high_qty_unit_price'] = '';
                            newArr[id].new['min_price'] = '';
                            newArr[id].error = false;
                            newArr[id].edit = false;
                            newArr[id].add = false;
                            newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_size'], ['asc']);
                            this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                        } else {
                            newArr[id].error = true;
                        }
                    } else {
                        newArr[id].error = false;
                        newArr[id].edit = false;
                        newArr[id].add = false;
                        newArr[id].prices = _.orderBy(newArr[id].prices, ['paper_size'], ['asc']);
                        this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { prices: newArr[id].prices } }, this.props.offline);
                    }
                    this.setState({ pricing: newArr });
                }
                break;

            case 'misc':
                if (newArr[id].edit) {
                    newArr[id].diecut_min_price = (newArr[id].diecut_min_price) ? newArr[id].diecut_min_price : 0.0;
                    newArr[id].spotuv_min_price = (newArr[id].spotuv_min_price) ? newArr[id].spotuv_min_price : 0.0;
                    newArr[id].saddlestitch_min_price = (newArr[id].saddlestitch_min_price) ? newArr[id].saddlestitch_min_price : 0.0;
                    newArr[id].saddlestitch_cutoff_qty = (newArr[id].saddlestitch_cutoff_qty) ? newArr[id].saddlestitch_cutoff_qty : 0;
                    newArr[id].saddlestitch_price_increment = (newArr[id].saddlestitch_price_increment) ? newArr[id].saddlestitch_price_increment : 0.0;
                    newArr[id].perfectbind_min_price = (newArr[id].perfectbind_min_price) ? newArr[id].perfectbind_min_price : 0.0;
                    newArr[id].perfectbind_cutoff_qty = (newArr[id].perfectbind_cutoff_qty) ? newArr[id].perfectbind_cutoff_qty : 0;
                    newArr[id].perfectbind_price_increment = (newArr[id].perfectbind_price_increment) ? newArr[id].perfectbind_price_increment : 0.0;
                    newArr[id].folding_min_price = (newArr[id].folding_min_price) ? newArr[id].folding_min_price : 0.0;
                    newArr[id].folding_cutoff_qty = (newArr[id].folding_cutoff_qty) ? newArr[id].folding_cutoff_qty : 0;
                    newArr[id].folding_price_increment = (newArr[id].folding_price_increment) ? newArr[id].folding_price_increment : 0.0;
                    newArr[id].numbering_min_price = (newArr[id].numbering_min_price) ? newArr[id].numbering_min_price : 0.0;
                    newArr[id].threadsewing_min_price = (newArr[id].threadsewing_min_price) ? newArr[id].threadsewing_min_price : 0.0;
                    newArr[id].edit = false;
                    this.props.updateBookletPricingTable({ name: this.state.product_name, cat: id, updates: { ...newArr[id], edit: undefined } }, this.props.offline);
                    this.setState({ pricing: newArr });
                }
                break;

            default:
                break;
        }
    }

    renderDigitalPaper() {
        const { material } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Digital Paper</Header>
                <Form>
                    <Table compact celled selectable={material.edit}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Weight (G)</Table.HeaderCell>
                                <Table.HeaderCell>Paper Type</Table.HeaderCell>
                                <Table.HeaderCell>Unit Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'material')} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {material.prices &&
                                material.prices.map((price, row) => (
                                    <Table.Row key={row}>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="1" name="weight" value={price.weight} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="text" name="paper_type" value={price.paper_type} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="unit_price" defaultValue={price.unit_price} value={price.unit_price} disabled={!material.edit} onChange={this.handleTableInputChange.bind(this, 'material', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            <Icon name={(material.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, 'material', row, null)} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            }
                            {(material.add) &&
                                <Table.Row warning={!material.error} error={material.error}>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="1" name="weight" value={material.new.weight} onChange={this.handleTableInputChange.bind(this, 'material', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="text" name="paper_type" value={material.new.paper_type} onChange={this.handleTableInputChange.bind(this, 'material', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="unit_price" value={material.new.unit_price} onChange={this.handleTableInputChange.bind(this, 'material', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Icon name="undo" onClick={this.handleResetRow.bind(this, 'material')} />
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                        <Table.Footer fullWidth>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <Form.Field>
                                        <label>Minimum Paper Price (RM)</label>
                                        <input type="number" step="0.01" name="min_paper_price" value={material.min_paper_price} disabled={!material.edit} onChange={this.handleGroupInputChange.bind(this, 'material', null)} />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Minimum Card Price (RM)</label>
                                        <input type="number" step="0.01" name="min_card_price" value={material.min_card_price} disabled={!material.edit} onChange={this.handleGroupInputChange.bind(this, 'material', null)} />
                                    </Form.Field>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan="3">
                                    {
                                        (material.edit) &&
                                        <Fragment>
                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!material.edit} onClick={this.handleAddRow.bind(this, 'material', null)}>
                                                <Icon name="add" />Add
                                            </Button>
                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!material.edit} onClick={this.handleSaveClicked.bind(this, 'material', null)}>
                                                <Icon name="save" />Save
                                            </Button>
                                        </Fragment>
                                    }
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderPrinting() {
        const { printing } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Printing</Header>
                <Segment.Group>
                    {
                        printing.map((printing, index) => (
                            <Segment key={index}>
                                <Form>
                                    <Table compact celled selectable={false}>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell colSpan="4" textAlign="center">{printing.type} {printing.material}</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Page Range (From)</Table.HeaderCell>
                                                <Table.HeaderCell>Unit Price (RM)</Table.HeaderCell>
                                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'printing', index)} /></Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {printing.prices &&
                                                printing.prices.map((price, row) => (
                                                    <Table.Row key={row}>
                                                        <Table.Cell>
                                                            <Form.Field control="input" type="number" step="1" name="from" value={price.from} disabled={!printing.edit} onChange={this.handleTableInputChange.bind(this, 'printing', row, index)} />
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <Form.Field control="input" type="number" step="0.01" name="unit_price" value={price.unit_price} disabled={!printing.edit} onChange={this.handleTableInputChange.bind(this, 'printing', row, index)} />
                                                        </Table.Cell>
                                                        <Table.Cell collapsing>
                                                            <Icon name={(printing.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, 'printing', row, index)} />
                                                        </Table.Cell>
                                                    </Table.Row>
                                                ))
                                            }
                                            {printing.add &&
                                                <Table.Row warning={!printing.error} error={printing.error}>
                                                    <Table.Cell>
                                                        <Form.Field control="input" type="number" step="1" name="from" value={printing.new.from} disabled={!printing.edit} onChange={this.handleTableInputChange.bind(this, 'printing', -1, index)} />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Form.Field control="input" type="number" step="0.01" name="unit_price" value={printing.new.unit_price} disabled={!printing.edit} onChange={this.handleTableInputChange.bind(this, 'printing', -1, index)} />
                                                    </Table.Cell>
                                                    <Table.Cell collapsing>
                                                        <Icon name="undo" onClick={this.handleResetRow.bind(this, 'printing', index)} />
                                                    </Table.Cell>
                                                </Table.Row>
                                            }
                                        </Table.Body>
                                        <Table.Footer fullWidth>
                                            <Table.Row>
                                                <Table.HeaderCell>
                                                    <Form.Field>
                                                        <label>Minimum Printing Price (RM)</label>
                                                        <input type="number" step="0.01" name="min_printing_price" value={printing.min_printing_price} disabled={!printing.edit} onChange={this.handleGroupInputChange.bind(this, 'printing', index)} />
                                                    </Form.Field>
                                                </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="3">
                                                    {
                                                        (printing.edit) &&
                                                        <Fragment>
                                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!printing.edit} onClick={this.handleAddRow.bind(this, 'printing', index)}>
                                                                <Icon name="add" />Add
                                                            </Button>
                                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!printing.edit} onClick={this.handleSaveClicked.bind(this, 'printing', index)}>
                                                                <Icon name="save" />Save
                                                            </Button>
                                                        </Fragment>
                                                    }
                                                </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Footer>
                                    </Table>
                                </Form>
                            </Segment>
                        ))
                    }
                </Segment.Group>
            </Segment>
        )
    }

    renderLamination() {
        const { lamination } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Lamination</Header>
                <Form>
                    <Table compact celled selectable={false}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>1-Sided Minimum Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell>2-Sided Minimum Price (RM)</Table.HeaderCell>
                                <Table.HeaderCell>Price Per Square Inch (RM)</Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'lamination', null)} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field control="input" type="number" step="0.01" name="one_sided_min_price" value={lamination.one_sided_min_price} disabled={!lamination.edit} onChange={this.handleGroupInputChange.bind(this, 'lamination', null)} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field control="input" type="number" step="0.01" name="two_sided_min_price" value={lamination.two_sided_min_price} disabled={!lamination.edit} onChange={this.handleGroupInputChange.bind(this, 'lamination', null)} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field control="input" type="number" name="price_per_sq_inch" value={lamination.price_per_sq_inch} disabled={!lamination.edit} onChange={this.handleGroupInputChange.bind(this, 'lamination', null)} />
                                </Table.Cell>
                                <Table.Cell collapsing>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        {lamination.edit &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="4">
                                        <Button floated="right" icon labelPosition="left" primary size="small" disabled={!lamination.edit} onClick={this.handleSaveClicked.bind(this, 'lamination')}>
                                            <Icon name="save" />Save
                                        </Button>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderWireO() {
        const { wire_o } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Wire-O</Header>
                <Form>
                    <Table compact celled selectable={wire_o.edit}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Size</Table.HeaderCell>
                                <Table.HeaderCell>Cut-off Quantity</Table.HeaderCell>
                                <Table.HeaderCell>Low Quantity Unit Price</Table.HeaderCell>
                                <Table.HeaderCell>High Quantity Unit Price</Table.HeaderCell>
                                <Table.HeaderCell>Minimum Price</Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'wire_o')} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {wire_o.prices &&
                                wire_o.prices.map((price, row) => (
                                    <Table.Row key={row}>
                                        <Table.Cell>
                                            <Form.Field control="input" type="text" name="paper_size" value={price.paper_size} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="1" name="cutoff_quantity" value={price.cutoff_quantity} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="low_qty_unit_price" value={price.low_qty_unit_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="high_qty_unit_price" value={price.high_qty_unit_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field control="input" type="number" step="0.01" name="min_price" value={price.min_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                        <Table.Cell collapsing>
                                            <Icon name={(wire_o.edit) ? 'delete' : ''} color="red" onClick={this.handleRowDelete.bind(this, 'wire_o', row, null)} />
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            }
                            {(wire_o.add) &&
                                <Table.Row warning={!wire_o.error} error={wire_o.error}>
                                    <Table.Cell>
                                        <Form.Field control="input" type="text" name="paper_size" value={wire_o.new.paper_size} onChange={this.handleTableInputChange.bind(this, 'wire_o', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="1" name="cutoff_quantity" value={wire_o.new.cutoff_quantity} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="low_qty_unit_price" value={wire_o.new.low_qty_unit_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="high_qty_unit_price" value={wire_o.new.high_qty_unit_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Form.Field control="input" type="number" step="0.01" name="min_price" value={wire_o.new.min_price} disabled={!wire_o.edit} onChange={this.handleTableInputChange.bind(this, 'wire_o', -1, null)} />
                                    </Table.Cell>
                                    <Table.Cell collapsing>
                                        <Icon name="undo" onClick={this.handleResetRow.bind(this, 'wire_o')} />
                                    </Table.Cell>
                                </Table.Row>
                            }
                        </Table.Body>
                        {(wire_o.edit) &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="6">
                                        <Fragment>
                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!wire_o.edit} onClick={this.handleAddRow.bind(this, 'wire_o', null)}>
                                                <Icon name="add" />Add
                                            </Button>
                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!wire_o.edit} onClick={this.handleSaveClicked.bind(this, 'wire_o', null)}>
                                                <Icon name="save" />Save
                                            </Button>
                                        </Fragment>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    renderMiscellaneous() {
        const { misc } = this.state.pricing;

        return (
            <Segment>
                <Header as="h3" textAlign="center">Miscellaneous</Header>
                <Form>
                    <Table compact celled selectable={false}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="4"></Table.HeaderCell>
                                <Table.HeaderCell collapsing><Icon name="edit" onClick={this.handleEditClicked.bind(this, 'misc', null)} /></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Die Cut</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="diecut_min_price" value={misc.diecut_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Spot UV</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="spotuv_min_price" value={misc.spotuv_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Saddles Stitch</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="saddlestitch_min_price" value={misc.saddlestitch_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Cut-off Quantity</label>
                                        <Input type="number" step="1" name="saddlestitch_cutoff_qty" value={misc.saddlestitch_cutoff_qty} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Price Increment (RM)</label>
                                        <Input type="number" step="0.01" name="saddlestitch_price_increment" value={misc.saddlestitch_price_increment} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Perfect Bind</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="perfectbind_min_price" value={misc.perfectbind_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Cut-off Quantity</label>
                                        <Input type="number" step="1" name="perfectbind_cutoff_qty" value={misc.perfectbind_cutoff_qty} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Price Increment (RM)</label>
                                        <Input type="number" step="0.01" name="perfectbind_price_increment" value={misc.perfectbind_price_increment} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Folding</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="folding_min_price" value={misc.folding_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Cut-off Quantity</label>
                                        <Input type="number" step="1" name="folding_cutoff_qty" value={misc.folding_cutoff_qty} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Price Increment (RM)</label>
                                        <Input type="number" step="0.01" name="folding_price_increment" value={misc.folding_price_increment} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Numbering</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="numbering_min_price" value={misc.numbering_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="5" textAlign="center">Threadsewing</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    <Form.Field>
                                        <label>Minimum Price (RM)</label>
                                        <Input type="number" step="0.01" name="threadsewing_min_price" value={misc.threadsewing_min_price} disabled={!misc.edit} onChange={this.handleGroupInputChange.bind(this, 'misc', null)} />
                                    </Form.Field>
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                        {
                            (misc.edit) &&
                            <Table.Footer fullWidth>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="5">
                                        <Fragment>
                                            <Button floated="right" icon labelPosition="left" primary size="small" disabled={!misc.edit} onClick={this.handleSaveClicked.bind(this, 'misc')}>
                                                <Icon name="save" />Save
                                                    </Button>
                                        </Fragment>
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        }
                    </Table>
                </Form>
            </Segment>
        )
    }

    render() {
        const { product_name, pricing } = this.state;

        return (
            <Container>
                <Header as="h2">{product_name}</Header>
                <Segment.Group raised>
                    {(pricing.material) &&
                        this.renderDigitalPaper()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.material) &&
                        this.renderPrinting()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.material) &&
                        this.renderLamination()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.wire_o) &&
                        this.renderWireO()
                    }
                </Segment.Group>
                <Segment.Group raised>
                    {(pricing.material) &&
                        this.renderMiscellaneous()
                    }
                </Segment.Group>
            </Container>
        )
    }
}

const mapStateToProps = ({ product }) => {
    return { product };
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        hideLoading: hideLoading,
        getBookletPricing: getBookletPricing,
        getProductOptions: getProductOptions,
        updateBookletPricingTable: updateBookletPricingTable
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(DigitalBooklet);